import { render, staticRenderFns } from "./coursesPage.vue?vue&type=template&id=596265b6&scoped=true&"
import script from "./coursesPage.vue?vue&type=script&lang=ts&"
export * from "./coursesPage.vue?vue&type=script&lang=ts&"
import style0 from "./coursesPage.vue?vue&type=style&index=0&id=596265b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596265b6",
  null
  
)

export default component.exports